import { render, staticRenderFns } from "./DatosCompradorComponent.vue?vue&type=template&id=0bd3f230"
import script from "./DatosCompradorComponent.vue?vue&type=script&lang=js"
export * from "./DatosCompradorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports